import React from 'react';
import { useState, useEffect, Fragment } from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import * as Icons from 'react-bootstrap-icons';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Confirmation from './ConfirmationModal';

const SiteAdd = ({show, callback}) => {
  //const handleClose = () => set
  //console.log('organization', show)
  //const [show, setShow] = useState(false);
  //const handleClose = () => setShow(false);
  const [ addFormData, setAddFormData ] = useState({
    name: '',
  })

  const handleAddFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute('name');
    const fieldValue = event.target.value;

    const newFormData = { ...addFormData };
    newFormData[fieldName] = fieldValue;

    setAddFormData(newFormData);

    console.log('handleSave-newFormData',newFormData)
  }


  const handleSave = (event) => {
    event.preventDefault();
    console.log('handleSave', addFormData)
    callback(addFormData);
  }

  const closeForm = () => {
    callback("close");
  }

  return (
    <>
      <Modal
        show={show}
        onHide={closeForm}
        backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Add Site</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form onSubmit={handleSave}>
                <Form.Label>Organization Id</Form.Label>
                <Form.Control name="organization_id" type="text" placeholder="Organization Id" onChange={handleAddFormChange} />

                <Form.Label>Nimi</Form.Label>
                <Form.Control name="name" type="text" placeholder="Nimi" onChange={handleAddFormChange} />

                <Form.Label>Description</Form.Label>
                <Form.Control name="description" type="text" placeholder="Selite" onChange={handleAddFormChange} />

                <Form.Label>Personnel Id</Form.Label>
                <Form.Control name="personnel_id" type="text" placeholder="Personnel Id"  onChange={handleAddFormChange} />

                <Form.Label>GPS</Form.Label>
                <Form.Control name="gps" type="text" placeholder="Coordinates"  onChange={handleAddFormChange} />

                <Form.Label>Status</Form.Label>
                <Form.Control name="status" type="text" placeholder="Status"  onChange={handleAddFormChange} />

                {/*<Button type="submit">Save</Button>*/}
            </Form>

          </Modal.Body>

          <Modal.Footer>
            <Button onClick={closeForm}>Cancel</Button>
            <Button onClick={handleSave}>Save</Button>
          </Modal.Footer>

        </Modal>
    </>
  )
}

const ReadOnlyRow = ({ site, handleEditClick, handleDeleteRow, organizations, personnel }) => {
  // Comboboxin teksti = organisaation nimi
  var org_title = organizations.find(x => x.id === Number(site.organization_id)).name;
//  if (personnel.find(x => x.id === Number(site.personnel_id)) == undefined)
//    console.log('info', org_title, site.personnel_id, 'undefined', site.id)
  var personFound = personnel.find(x => x.id === Number(site.personnel_id));
  var personnel_name = (personFound !== undefined) ? personFound.name : 'na';

  return (             
    <tr>
      <td><b>{site['id']}</b></td>
      <td><b>{org_title}</b></td>
      <td><b>{site['name']}</b></td>
      <td>{site['description']}</td>
      <td>{personnel_name}</td>
      <td>{site['gps']}</td>
      <td>{site['status']}</td>
      <td>
        <button className="btn btn-primary" title="Edit" onClick={(event) => handleEditClick(event, site)}><Icons.Pencil /></button>
        <button className="btn btn-primary" title="Delete" onClick={() => handleDeleteRow(site['id'])}><Icons.Trash/></button>
      </td>
    </tr>
  )
}

// Editoitava site rivi
const EditableRow = ({ editFormData, handleEditFormChange, handleCancelClick, handleEditFormSelect, organizations, personnel }) => {
  console.log('edit able row begin', editFormData)

  // Comboboxin teksti = organisaation nimi
  var org_title = organizations.find(x => x.id === Number(editFormData.organization_id)).name;
  // Comboboxissa näytettävät organisaatiot
  var org_items = [];
  organizations.map((org) => {
    org_items = org_items.concat(<Dropdown.Item name="organization_id" eventKey={org.id} >{org.name}</Dropdown.Item>);
  });

  // Comboboxin teksti - yhteyshenkilön nimi
  var personnel_title = personnel.find(x => x.id === Number(editFormData.personnel_id)).name;
  // Comboboxissa näytettävien henkilöiden nimet
  var personnel_items = [];
  personnel.map((person) => {
    personnel_items = personnel_items.concat(<Dropdown.Item name="personnel_id" eventKey={person.id} >{person.name}</Dropdown.Item>);
  })


  return (
    <tr>
      <td><b>{editFormData.id}</b></td>
      {/*<td><b><input type="text" required="required" placeholder="Enter organization id" name="organization_id" value={editFormData.name} onChange={handleEditFormChange} ></input></b></td>*/}

      <td>
        <DropdownButton required="required" title={org_title} onSelect={handleEditFormSelect}>
          {org_items}
        </DropdownButton>
      </td>
 

      <td><b><input type="text" required="required" placeholder="Enter name" name="name" value={editFormData.name} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter description" name="description" value={editFormData.description} onChange={handleEditFormChange} ></input></b></td>


      {/*<td><b><input type="text" required="required" placeholder="Enter personnel id" name="personnel_id" value={editFormData.personnel_id} onChange={handleEditFormChange} ></input></b></td>*/}
      <td>
        <DropdownButton required="required" title={personnel_title} onSelect={handleEditFormSelect}>
          {personnel_items}
        </DropdownButton>
      </td>



      <td><b><input type="text" placeholder="Enter gps" name="gps" value={editFormData.gps} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter status" name="status" value={editFormData.status} onChange={handleEditFormChange} ></input></b></td>
      <td>
        <button className="btn btn-primary" type="button" onClick={handleCancelClick}>Cancel</button>
        <button className="btn btn-primary" type="submit">Save</button>
      </td>
    </tr>
  )
}




const Sites = ({database, main_callback}) => {
  var sites = database['sites'];
  var organizations = database['organizations'];
  var personnel = database['personnel'];

  const [show, setShow] = useState(false);
  const [editSiteId, setEditSiteId] = useState(null);
  const [editFormData, setEditFormData] = useState([]);

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [rowIdToDelete, setRowIdToDelete] = useState(null);

  const eventFromChild = (event) => {
    console.log('event from child', event)
    // TODO: Laitetaanko tähän tallennus vai viedäänkö Appin tasolle?
    // Suljettaessa formia tulee ainoastaan teksti close
    if (event !== "close")
      main_callback('add', 'sites', event);
    
    setShow(false);
  }

  // Edit kenttää muutettu
  const handleEditFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);

    console.log('edit changed', newFormData)
  };

    // Valittu alasvetovalikosta
    const handleEditFormSelect = (eventKey, event)  => {
      const fieldName = event.target.getAttribute("name");
      const fieldValue = eventKey;
  
      const newFormData = { ...editFormData };
      newFormData[fieldName] = fieldValue;
  
      setEditFormData(newFormData);
    };
  

  // Editoitavalla rivillä painetaan save-nappia
  const handleEditFormSubmit = (event) => {
    event.preventDefault();

    const editedSite = {
      id: editSiteId,
      organization_id: editFormData.organization_id,
      name: editFormData.name,
      description: editFormData.description,
      personnel_id: editFormData.personnel_id,
      gps: editFormData.gps,
      status: editFormData.status
    }

    const newSite = [...sites];
    const index = sites.findIndex((site) => site.id === editFormData.id);
    newSite[index] = editFormData;
    //setEditFormData(newOrganization);
    console.log('edit submit', editSiteId, newSite)
    
    main_callback('update', 'sites', newSite);
    
    setEditSiteId(null);
  }

  // Editoitavalla painetaan cancel-nappia
  const handleCancelClick = () => {
    console.log('edit cancelled')
    setEditSiteId(null);
  }


  // ReadOnly-rivillä painetaan edit-nappia
  const handleEditClick = (event, site) => {
    console.log('edit click', event, site)
    event.preventDefault();
    setEditSiteId(site.id);

    const formValues = {
      id: site.id,
      organization_id: site.organization_id,
      name: site.name,
      description: site.description,
      personnel_id: site.personnel_id,
      gps: site.gps,
      status: site.status
    };

    console.log('edit click form', formValues)

    setEditFormData(formValues);
    console.log('edit click after', editFormData)
  };



  // Read-only rivillä painetaan deleteä -> näytetään varmistusdialogi (alla)
  const handleDeleteRow = (id) => {
    console.log('handleDeleteRow', id)
    setRowIdToDelete(id);

    // Kysytään varmistus poistoon
    setShowConfirmation(true);
  }

  // Jos käyttäjä vahvistaa poiston -> lähetetään backendille poistettavan rivin id
  const confirmation_callback = (confirmation) =>{
    if (confirmation === "confirm") {
      main_callback('delete', 'sites', rowIdToDelete)
      setRowIdToDelete(null);
    }

    // Piiletetaan lopuksi vahvistusdialogi
    setShowConfirmation(false);
  }
  


  return (
        <>
        <h2>Suojauskohteet</h2>
        <form onSubmit={handleEditFormSubmit}>
        <Table>
        <thead>
          <tr>
            <th>Id</th>
            <th>Org Id</th>
            <th>Nimi</th>
            <th>Selite</th>
            <th>Yhteyshenkilö</th>
            <th>GPS</th>
            <th>Huoltotila</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {sites.map((site) => (
              <Fragment key={site.id}>
              {editSiteId === site.id ? (
                <EditableRow editFormData={editFormData} handleEditFormChange={handleEditFormChange} handleCancelClick={handleCancelClick} handleEditFormSelect={handleEditFormSelect} organizations={organizations} personnel={personnel} />
              ) : (
                <ReadOnlyRow site={site} handleEditClick={handleEditClick} handleDeleteRow={handleDeleteRow} organizations={organizations} personnel={personnel}/>
              )}

            </Fragment>

          ))}
        </tbody>

      </Table>
      </form>

      <SiteAdd show={show} callback={eventFromChild}></SiteAdd>

      <Confirmation className="delete-confirmation" show={showConfirmation} callback={confirmation_callback}></Confirmation>
    
      <button 
        className="btn btn-primary" 
        onClick={() => setShow(true)}>
          Lisää
      </button>

      </>
    )
}

export default Sites;